var map = {
	"./circ3dshell.jpg": 38,
	"./circ3dslice.jpg": 39,
	"./circ3dufo.jpg": 40,
	"./cyl3dflower.jpg": 41,
	"./cyl3dslice.jpg": 42,
	"./cyl3dstair.jpg": 43,
	"./polar2dnut.jpg": 44,
	"./polar2dtri.jpg": 45,
	"./rec2dmin.jpg": 46,
	"./rec2dsin.jpg": 47,
	"./rec3dgaussian.jpg": 48,
	"./rec3dhemi.jpg": 49,
	"./rec3dvalley.jpg": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;